/**
 * Builds the primary-DB connection URL, applying the `DATABASE_NAME` env var
 * (used by ephemeral PR envs for database-level isolation) when set.
 */
export function getPrimaryDatabaseUrl(): string {
  const baseUrl = process.env["PRIMARY_DATABASE_URL"];
  if (!baseUrl) {
    throw new Error("PRIMARY_DATABASE_URL is not set");
  }

  const dbName = process.env["DATABASE_NAME"];
  if (!dbName) {
    return baseUrl;
  }

  const url = new URL(baseUrl);
  url.pathname = `/${dbName}`;
  return url.toString();
}
